module.exports = __webpack_public_path__ + "img/es.69bf7c3d.png";